module.exports = __webpack_public_path__ + "assets/img/omplete.62227b27.svg";